import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import AuthStore from './modules/AuthStore';
import RouteStore from './modules/RouteStore';
import ShohiyouStore from './modules/ShohiyouStore';
import EnvironmentStore from './modules/EnvironmentStore';
import Socket from "./modules/socketStore";
import Menu from "./modules/menuStore";

Vue.use(Vuex);

const namespaced: boolean = true;
const store: StoreOptions<any> = {
    modules: {
        AuthStore,
        RouteStore,
        ShohiyouStore,
        EnvironmentStore,
        Socket,
        Menu
    },
};

export default new Vuex.Store<any>(store);
